import { useSuspenseDomainQuery } from '#api/domains.queries.ts';
import { Code } from '#components/atoms/code/Code.tsx';
import { DomainDetailsTable } from './DomainDetailsTable.tsx';

type Props = {
  domainId: string;
};

export function VerificationSteps({ domainId }: Props) {
  const {
    data: { data: domain },
  } = useSuspenseDomainQuery(domainId);
  return (
    <>
      <h2 className="h3">1. Add TXT record for domain: {domain.domainName}</h2>
      <DomainDetailsTable domain={domain} className="mb-16" />
      <p className="p-md mb-40">
        To confirm you own this domain, please create a TXT record at your DNS provider for{' '}
        <Code>
          {domain.zone}.{domain.domainName}
        </Code>{' '}
        with the value above.
      </p>
      <h2 className="h3">2. Save and wait</h2>
      <ul className="ul-md mb-40">
        <li className="p-md">Save your changes in your DNS provider.</li>
        <li className="p-md">It may take a few minutes for DNS changes to propagate (sometimes up to 24 hours).</li>
      </ul>
      <h2 className="h3">3. Verify ownership</h2>
      <p className="p-md mb-16">Click the button below. Once verified, your domain will be available for use.</p>
    </>
  );
}
